(function () {
  'use strict';
  if (window.VSGifts) return;
  var config = null;
  var configPromise = null;
  var pending = {};
  var saving = false;
  var timer;
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  function widgets() { return Array.from(document.querySelectorAll('[data-vsg]')); }
  function message(widget, key) {
    try { return JSON.parse(widget.querySelector('[data-vsg-i18n]').textContent)[key] || ''; }
    catch (error) { return ''; }
  }
  function configRequest() {
    if (configPromise) return configPromise;
    configPromise = fetch(root + 'apps/vs-lucky-drop/gifts', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('gift_config_unavailable'); return r.json(); })
      .then(function (data) { if (!data || typeof data.enabled !== 'boolean') throw new Error('invalid_gift_config'); config = data; return data; })
      .catch(function () { config = { enabled: false }; return config; });
    return configPromise;
  }
  function init() {
    var current = widgets();
    if (!current.length) return;
    current.forEach(function (widget) {
      if (widget.dataset.preview === 'true' || widget.dataset.demo === 'true') return;
      widget.hidden = true;
    });
    if (current.every(function (w) { return w.dataset.preview === 'true' || w.dataset.demo === 'true'; })) return;
    configRequest().then(function (data) {
      widgets().forEach(function (widget) {
        if (widget.dataset.preview === 'true' || widget.dataset.demo === 'true') return;
        widget.hidden = !data.enabled;
        var preview = widget.querySelector('[data-vsg-preview]');
        if (preview) preview.hidden = true;
        ['liquid', 'box'].forEach(function (kind) {
          var reward = widget.querySelector('[data-vsg-tier="' + kind + '"]');
          var gift = data.gifts && data.gifts[kind];
          if (reward && gift && gift.available === false) {
            reward.querySelector('[data-vsg-tier-status]').textContent = message(widget, 'noStock');
            reward.dataset.earned = 'false';
            reward.dataset.available = 'false';
          }
          if (reward && gift && gift.available !== false) {
            reward.removeAttribute('data-available');
            if (gift.thumbnail) reward.querySelector('img').src = gift.thumbnail;
          }
        });
        if (data.gifts && data.gifts.box && !data.gifts.box.available) widget.querySelector('[data-vsg-options]').hidden = true;
      });
    });
  }
  function announce(key) {
    widgets().filter(function (w) { return w.dataset.demo !== 'true'; }).forEach(function (w) {
      w.querySelector('[data-vsg-status]').textContent = message(w, key);
    });
  }
  function save() {
    if (saving || !Object.keys(pending).length || !config || !config.enabled) return;
    if (window.VSCartMutation && !window.VSCartMutation.begin('gift-options')) return;
    saving = true;
    var succeeded = false;
    var attributes = Object.assign({}, pending);
    pending = {};
    var request = window.VSCartMutation ? window.VSCartMutation.request : fetch;
    request(root + 'cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function (response) {
      if (!response.ok) throw new Error('gift_options_not_saved');
      return response.json();
    }).then(function (cart) {
      var saved = cart.attributes || {};
      if (Object.keys(attributes).some(function (key) { return saved[key] !== attributes[key]; })) throw new Error('gift_options_not_saved');
      succeeded = true;
      announce('saved');
    }).catch(function () {
      Object.keys(attributes).forEach(function (key) { if (!(key in pending)) pending[key] = attributes[key]; });
      announce('saveError');
    }).finally(function () {
      saving = false;
      if (window.VSCartMutation) window.VSCartMutation.end('gift-options');
      if (succeeded && Object.keys(pending).length) timer = setTimeout(save, 100);
    });
  }
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-vsg-option]');
    if (!select) return;
    var widget = select.closest('[data-vsg]');
    if (widget.dataset.demo === 'true' || widget.dataset.preview === 'true') {
      widget.querySelector('[data-vsg-status]').textContent = message(widget, 'demoSaved');
      return;
    }
    if (!config || !config.enabled) return;
    pending[select.dataset.vsgOption] = select.value;
    pending.vs_gift_program = config.campaign || 'gifts-2026-10';
    clearTimeout(timer); save();
  });
  window.addEventListener('vs:cart-mutation-state', function (event) {
    if (!event.detail || event.detail.busy) return;
    init();
    if (event.detail.source !== 'gift-options' && Object.keys(pending).length) save();
  });
  document.addEventListener('cart:update', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('DOMContentLoaded', init);
  window.VSGifts = { init: init };
  init();
})();
